import * as moment from "moment";
var CandidateModel = /** @class */ (function () {
    function CandidateModel(inputCandidate) {
        this.candidate = inputCandidate;
    }
    Object.defineProperty(CandidateModel.prototype, "fullName", {
        get: function () {
            return this.candidate.User.name + " " + this.candidate.User.surname;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CandidateModel.prototype, "status", {
        get: function () {
            return "" + this.candidate.User.status;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CandidateModel.prototype, "birthdate", {
        get: function () {
            return this.candidate.User.birthdate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CandidateModel.prototype, "years", {
        get: function () {
            return moment().diff(this.birthdate, "years");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CandidateModel.prototype, "mail", {
        get: function () {
            return (this.candidate.User.contact_email || this.candidate.User.email || "-");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CandidateModel.prototype, "phone", {
        get: function () {
            return (this.candidate.User.contact_phone || this.candidate.User.phone || "-");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CandidateModel.prototype, "address", {
        get: function () {
            return this.candidate.User.contact_address || "-";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CandidateModel.prototype, "profileImage", {
        get: function () {
            return this.candidate.User.img || "assets/img/avatar-orange.png";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CandidateModel.prototype, "notViewed", {
        get: function () {
            return !this.candidate.viewed;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CandidateModel.prototype, "userId", {
        get: function () {
            return this.candidate.User.id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CandidateModel.prototype, "educations", {
        get: function () {
            var educations = [];
            this.candidate.User.AcademicQualifications.forEach(function (edu) {
                var education = new EducationDataModel();
                education.macroStudyTag = edu.StudyTag.MacroStudyTag.name_en;
                education.studyTag = edu.StudyTag.name_en;
                education.course = edu.course_name;
                education.university = edu.university_name;
                education.graduationLabel = edu.finished_at
                    ? "graduation"
                    : "expected graduation";
                education.graduationDate = edu.finished_at
                    ? new Date(edu.finished_at)
                    : new Date(edu.expected_finished_at);
                education.voteLabel = edu.vote ? "vote" : "average";
                education.vote = edu.vote
                    ? String(edu.vote)
                    : edu.avg
                        ? String(edu.avg)
                        : "-";
                education.qualification = edu.qualification_name;
                education.isCompleted = edu.courses_id !== null;
                education.noVoteNoAvg = edu.vote === null && edu.avg === null;
                educations.push(education);
            });
            return educations;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CandidateModel.prototype, "jobOffers", {
        get: function () {
            return this.candidate.User.UserJobs;
        },
        enumerable: true,
        configurable: true
    });
    return CandidateModel;
}());
export { CandidateModel };
var EducationDataModel = /** @class */ (function () {
    function EducationDataModel() {
        this.macroStudyTag = null;
        this.studyTag = null;
        this.course = null;
        this.university = null;
        this.graduationLabel = null;
        this.graduationDate = null;
        this.voteLabel = null;
        this.vote = null;
        this.qualification = null;
        this.isCompleted = false;
        this.noVoteNoAvg = false;
    }
    return EducationDataModel;
}());
export { EducationDataModel };
var UserModel = /** @class */ (function () {
    function UserModel() {
    }
    return UserModel;
}());
export { UserModel };
var CourseModel = /** @class */ (function () {
    function CourseModel() {
    }
    return CourseModel;
}());
export { CourseModel };
var UniversityCourseViewModel = /** @class */ (function () {
    function UniversityCourseViewModel() {
    }
    return UniversityCourseViewModel;
}());
export { UniversityCourseViewModel };
var UserJobsEntityModel = /** @class */ (function () {
    function UserJobsEntityModel() {
    }
    return UserJobsEntityModel;
}());
export { UserJobsEntityModel };
var TagsEntity = /** @class */ (function () {
    function TagsEntity() {
    }
    return TagsEntity;
}());
export { TagsEntity };
var ApplicationHasTags = /** @class */ (function () {
    function ApplicationHasTags() {
    }
    return ApplicationHasTags;
}());
export { ApplicationHasTags };
var JobOfferModel = /** @class */ (function () {
    function JobOfferModel() {
    }
    return JobOfferModel;
}());
export { JobOfferModel };
var AcademicQualificationsEntityModel = /** @class */ (function () {
    function AcademicQualificationsEntityModel() {
    }
    return AcademicQualificationsEntityModel;
}());
export { AcademicQualificationsEntityModel };
var CityModel = /** @class */ (function () {
    function CityModel() {
    }
    return CityModel;
}());
export { CityModel };
var StudyTagModel = /** @class */ (function () {
    function StudyTagModel() {
    }
    return StudyTagModel;
}());
export { StudyTagModel };
var MacroStudyTagModel = /** @class */ (function () {
    function MacroStudyTagModel() {
    }
    return MacroStudyTagModel;
}());
export { MacroStudyTagModel };
var UserLanguagesEntityModel = /** @class */ (function () {
    function UserLanguagesEntityModel() {
    }
    return UserLanguagesEntityModel;
}());
export { UserLanguagesEntityModel };
